import { css } from '@emotion/react'
import { hexToRGB, Text, Theme, useTheme } from 'bold-ui'

import { getClusterMarkerSize } from './utils-map'

interface MapClusterMarkerProps {
  count: number
}

export function MapClusterMarker(props: Readonly<MapClusterMarkerProps>) {
  const { count } = props

  const theme = useTheme()
  const styles = createStyles(theme, count)

  return (
    <div css={styles.root}>
      <Text css={styles.count}>{count}</Text>
    </div>
  )
}

const createStyles = (theme: Theme, count: number) => {
  const size = getClusterMarkerSize(count)

  return {
    root: css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      background-color: ${hexToRGB(theme.pallete.primary.c30, 0.85)};
      box-shadow: ${theme.shadows.outer[10]};
      z-index: ${theme.zIndex.popper};
    `,
    count: css`
      color: ${theme.pallete.surface.main};
      font-weight: bold;
      font-size: ${count >= 100 ? '0.8125rem' : '0.875rem'};
      line-height: 1;
    `,
  }
}
